import type { PublicLeadKind } from './public-lead-api.interface';

export const StaffLeadSections = {
  Callbacks: 'callbacks',
  Feedback: 'feedback',
  Vacancies: 'vacancies',
  Birthdays: 'birthdays',
  ForeignRegistrations: 'foreign_registrations',
} as const;

export type StaffLeadSection =
  (typeof StaffLeadSections)[keyof typeof StaffLeadSections];

export const StaffLeadStatuses = {
  New: 'new',
  InProcess: 'in_process',
  Completed: 'completed',
  Canceled: 'canceled',
} as const;

export type StaffLeadStatus =
  (typeof StaffLeadStatuses)[keyof typeof StaffLeadStatuses];

export interface AdminLeadResponse {
  id: string;
  user_id?: string | null;
  kind: PublicLeadKind;
  staff_section: StaffLeadSection;
  status: StaffLeadStatus;
  source: string;
  title: string;
  message?: string | null;
  phone: string;
  guest_name?: string | null;
  rating?: number | null;
  promocode?: string | null;
  discount_percent?: number | null;
  page_path?: string | null;
  service_type?: string | null;
  service_id?: string | null;
  context_lines?: string[];
  assigned_manager_id?: string | null;
  staff_note?: string | null;
  created_at: string;
  updated_at: string;
}

export interface AdminLeadListResponse {
  data: AdminLeadResponse[];
  total: number;
  next_cursor?: string | null;
}

export interface AdminLeadStatsResponse {
  callbacks_new: number;
  feedback_new: number;
  vacancies_new: number;
  birthdays_new: number;
  foreign_registrations_new: number;
}

export interface AdminLeadListQuery {
  section?: StaffLeadSection;
  kind?: PublicLeadKind;
  status?: StaffLeadStatus;
  search?: string;
  cursor?: string;
  limit?: number;
}

export interface PatchAdminLeadRequest {
  status?: StaffLeadStatus;
  staff_note?: string;
}
